"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchComponent = void 0;
var fetcher_1 = require("./fetcher");
Object.defineProperty(exports, "createFetchComponent", { enumerable: true, get: function () { return fetcher_1.createFetchComponent; } });
//# sourceMappingURL=index.js.map